<template>
  <div>
    <el-dialog
      append-to-body
      :title="`同意退货(订单号:${goodsreturn.dealOrderCode})`"
      :visible.sync="visible"
      width="480px"
      :close-on-press-escape="false">
      <el-form
        ref="ruleForm"
        :rules="rules"
        label-position="top"
        :model="goodsreturn"
        label-width="80px">
        <el-form-item
          label="退货仓库:"
          prop="warehouseNo">
          <el-input
            v-model="goodsreturn.warehouseName"
            readonly="">
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="selectWarehouse"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item
          label="退货明细:"
          prop="goodsReturnItems">
          <el-table
            border=""
            :data="goodsreturn.goodsReturnItems">
            <el-table-column
              min-width="180"
              property="productName"
              label="商品名称"></el-table-column>
            <el-table-column
              property="returnGoodsCount"
              label="退货数量"></el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item
          v-if="goodsreturn.billType === 2"
          label="关联售后单:"
          prop="postSaleOrderId">
          <el-input
            v-model="goodsreturn.postSaleOrderNumber"
            readonly="">
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="selectGoodsReturn"></el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <warehouse-select-modal
        ref="warehouse"
        :callback="warehouseCallback" />
      <transfer-select-modal
        ref="transfer"
        :callback="transferCallback" />
      <span
        slot="footer"
        class="dialog-footer">
        <el-button
          :loading="loading"
          @click="toggleModal(false)">取 消</el-button>
        <el-button
          type="primary"
          :loading="loading"
          @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import WarehouseSelectModal from '../../orders/busi/warehouse-select-modal.vue'
import TransferSelectModal from './transfer-select-modal.vue'
export default {
  name: 'AgreeReturnModal',
  components: { WarehouseSelectModal, TransferSelectModal },
  props: {
    fetch: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      goodsreturn: {
        goodsReturnId: null,
        postSaleOrderId: null,
        postSaleOrderNumber: null,
        warehouseNo: null,
        warehouseName: '',
        detailList: []
      },
      rules: {
        warehouseNo: [{ required: true, message: '请选择仓库', trigger: 'change' }],
        postSaleOrderId: [{ required: true, message: '请选择要关联的关联售后单', trigger: 'change' }]
      }
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
      // if (!visible) {
      //   this.goodsreturn = {
      //     detailList: []
      //   }
      // }
    },
    selectGoodsReturn() {
      this.$refs.transfer.fetch()
    },
    transferCallback(row) {
      this.$refs.transfer.toggleModal(false)
      this.goodsreturn.postSaleOrderId = row.postSaleOrderId
      this.goodsreturn.postSaleOrderNumber = row.postSaleOrderNumber
    },
    selectWarehouse() {
      this.$refs.warehouse.fetch({
        productType: 1, useType: 1
      })
    },
    warehouseCallback(row) {
      this.$set(this.goodsreturn, 'warehouseNo', row.warehouseNo)
      this.$set(this.goodsreturn, 'warehouseName', row.warehouseName)
      // this.goodsreturn.warehouseNo = row.warehouseNo
      // this.goodsreturn.warehouseName = row.warehouseName
    },
    init(info) {
      this.goodsreturn = {
        ...this.goodsreturn,
        ...info
      }
      this.toggleModal(true)
    },
    handleSubmit() {
      // const goodsReturnItems = this.goodsreturn.detailList.filter(i => i.returnGoodsCount > 0)
      // if (goodsReturnItems.length === 0) {
      //   this.$message.error('至少有一个商品的本次无码退货数量大于0')
      //   return
      // }
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$confirm('是否同意退货?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              this.loading = true
              this.$store.dispatch('goodsreturn/submitgoodsreturn', {
                payload: {
                  draftGoodsReturnId: this.goodsreturn.goodsReturnId,
                  warehouseNo: this.goodsreturn.warehouseNo,
                  postSaleOrderNumber: this.goodsreturn.postSaleOrderNumber
                },
                success: () => {
                  this.loading = false
                  this.toggleModal(false)
                  this.fetch && this.fetch()
                },
                fail: () => {
                  this.loading = false
                }
              })
            })
        }
      })
    }
  }
}
</script>
